import React from 'react';
import './RegistrationPending.css';
import SvgIcon from '../../components/SvgIcon';

const RegistrationPending = ({ registrationData, onSwitchView, onNavigate }) => {
  const handleLoginClick = () => (onSwitchView || onNavigate)?.('login');
  const data = registrationData || {};
  const orgName = data.organisationName || data.newOrganisationName || 'Government Ministry / Agency';
  const supervisorName = data.supervisorName || 'Supervisor on record';
  const supervisorEmail = data.supervisorEmail || 'Supervisor email on record';
  const referenceId = data.referenceId || 'GOV-PENDING';
  const email = data.email || 'Your registered email address';

  return (
    <div className="reg-pending-container" data-testid="registration-pending-view">
      <div className="reg-pending-card">
        
        {/* Header with Shield Clock Icon */}
        <div className="reg-pending-header">
          <div className="reg-pending-badge-icon">
            <SvgIcon name="shield" size={32} />
          </div>
          <h1 className="reg-pending-title">Civil Service Verification in Progress</h1>
          <p className="reg-pending-subtitle">
            Your government agency registration has been submitted and is currently undergoing administrative eligibility vetting.
          </p>
        </div>

        {/* 48-Hour Business Day SLA Banner */}
        <div className="reg-pending-sla-banner">
          <div style={{ color: '#f59e0b', marginTop: '2px' }}>
            <SvgIcon name="calendar" size={22} />
          </div>
          <div className="reg-pending-sla-content">
            <h4>48-Hour Business Day SLA Turnaround</h4>
            <p>
              Under BlackBerry CCoE civil service governance policies, government self-registrations undergo verification within <strong>48 business hours (2 full working days)</strong>, excluding weekends and official public holidays.
            </p>
          </div>
        </div>

        {/* Summary Card */}
        <div className="reg-pending-summary-card">
          <div className="summary-card-title">
            <span>Registration Intake Summary</span>
            <span className="summary-ref-badge" data-testid="ref-id-badge">{referenceId}</span>
          </div>

          <div className="summary-grid">
            <div className="summary-item">
              <span className="summary-label">Submitted Agency / Organisation</span>
              <span className="summary-value" data-testid="summary-org">{orgName}</span>
            </div>

            <div className="summary-item">
              <span className="summary-label">Supervisor Verification Contact</span>
              <span className="summary-value" data-testid="summary-supervisor">{supervisorName}</span>
              <span className="summary-subvalue">{supervisorEmail}</span>
            </div>

            <div className="summary-item">
              <span className="summary-label">Applicant Email</span>
              <span className="summary-value">{email}</span>
            </div>
          </div>
        </div>

        {/* Help & Support Contact Card */}
        <div className="reg-pending-support-card">
          <strong>Need immediate assistance or have an urgent intake deadline?</strong>
          <p style={{ margin: '4px 0 0 0' }}>
            Contact the BlackBerry Cybersecurity Center of Excellence Administration Desk:
          </p>
          <div className="support-links">
            <a href="mailto:ccoe-support@blackberry.local" className="support-link-item">
              <SvgIcon name="mail" size={14} />
              <span>ccoe-support@blackberry.local</span>
            </a>
            <span style={{ color: '#475569' }}>|</span>
            <span className="support-link-item">
              <SvgIcon name="help" size={14} />
              <span>Helpdesk Hours: Mon–Fri, 9:00 AM – 5:00 PM</span>
            </span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="reg-pending-actions">
          <button 
            type="button" 
            className="btn-primary-action"
            onClick={handleLoginClick}
            data-testid="return-to-login-btn"
          >
            Return to Login
          </button>
          <button 
            type="button" 
            className="btn-secondary-action"
            onClick={() => window.print ? window.print() : null}
          >
            Print Acknowledgement
          </button>
        </div>

      </div>
    </div>
  );
};

export default RegistrationPending;
